import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';

import { SectionTitle, TextBlock } from '@/components/ui';
import CreateOwnPhoneInput from '@/components/ui/CreateOwnPhoneInput/CreateOwnPhoneInput';
import {
  hooks as numberSaleHooks,
  selectors,
  actions,
} from '@/domains/number-sale';
import { patternMaker } from '@/utils/simNumberPattern';
import { numberLevels, numberSalePrefixes, defaultTab } from '@/constants/base';
import { NumberLevels, NumberSalePrefixIds } from '@/enums/numberSale';

import styles from './index.module.scss';

const FindYourSimNumber = ({ data }) => {
  const dispatch = useDispatch();
  const { activeTab, page } = useSelector(selectors.selectNumberSale);
  const [value, setValue] = useState(Array(7).fill(''));
  const [submittedValue, setSubmittedValue] = useState(Array(7).fill(''));
  const [prefix, setPrefix] = useState(numberSalePrefixes?.[0]);
  const [submittedPrefix, setSubmittedPrefix] = useState(
    numberSalePrefixes?.[0],
  );
  const [sortedData, setSortedData] = useState([]);

  useEffect(() => {
    setSortedData([]);
    dispatch(actions.setPage(1));
  }, [activeTab.value]);

  const { data: numbersData, isFetching } = numberSaleHooks.useGetNumbers({
    data: {
      page,
      size: 12,
      prefix:
        submittedPrefix.id === NumberSalePrefixIds.All
          ? null
          : submittedPrefix.name,
      numberPattern: patternMaker(submittedValue).join(''),
      ...(activeTab?.value && { numberLevels: activeTab.value }),
    },
  });

  useEffect(() => {
    if (numbersData?.numbers?.length) {
      setSortedData((prevData) => [...prevData, ...numbersData?.numbers]);
    } else {
      setSortedData([]);
    }
  }, [numbersData]);

  useEffect(() => {
    dispatch(actions.setActiveTab(numberLevels[0]));
  }, []);

  const loadMore = () => {
    dispatch(actions.setPage(page + 1));
  };

  const searchHandler = () => {
    if (
      prefix !== submittedPrefix ||
      JSON.stringify(value) !== JSON.stringify(submittedValue)
    ) {
      setSortedData([]);
      dispatch(actions.setPage(1));
      setSubmittedPrefix(prefix);
      setSubmittedValue(value);
    }
  };

  const resetHandler = () => {
    dispatch(actions.setPage(1));
    dispatch(actions.setActiveTab(defaultTab));
    setPrefix(numberSalePrefixes?.[0]);
    setSubmittedPrefix(numberSalePrefixes?.[0]);
    setValue(Array(7).fill(''));
    setSubmittedValue(Array(7).fill(''));
  };

  return (
    <div
      className={'wrapper section'}
      itemScope
      itemType='https://schema.org/Offer'
    >
      <div className={styles.intro}>
        <SectionTitle className={styles.title} titleModify={'title--large'}>
          {data?.title}
        </SectionTitle>
        <TextBlock className={classNames(['text--large', styles.description])}>
          {data?.description}
        </TextBlock>
      </div>

      <CreateOwnPhoneInput
        tabs={numberLevels}
        sortValue={prefix}
        detail={data}
        onChange={(val) => {
          setValue(val);
        }}
        isEsim={false}
        resetFields={resetHandler}
        value={value}
        onSubmit={searchHandler}
        sortData={numberSalePrefixes}
        data={sortedData}
        loadMore={loadMore}
        onSelect={setPrefix}
        totalPage={sortedData?.length}
        isLoading={isFetching}
      />
    </div>
  );
};

FindYourSimNumber.displayName = 'FindYourSimNumber';

export default FindYourSimNumber;
